<template>
  <div class="chart-box-cmp">
    <!--    <div-->
    <!--      :class="{-->
    <!--        loader:-->
    <!--          Object.keys(reportLeft).length === 0 ||-->
    <!--          Object.keys(reportRight).length === 0 ||-->
    <!--          Object.keys(reportCmp).length === 0,-->
    <!--        'd-none-for-loader':-->
    <!--          Object.keys(reportLeft).length > 0 ||-->
    <!--          Object.keys(reportRight).length > 0 ||-->
    <!--          Object.keys(reportCmp).length > 0-->
    <!--      }"-->
    <!--    ></div>-->
    <div
      :class="{
        'loader-div':
          Object.keys(reportLeft).length === 0 ||
          Object.keys(reportRight).length === 0 ||
          Object.keys(reportCmp).length === 0,
        'd-none-for-loader':
          Object.keys(reportLeft).length > 0 ||
          Object.keys(reportRight).length > 0 ||
          Object.keys(reportCmp).length > 0
      }"
    >
      <span class="insteadLoader"
        >GENERATING REPORT ,PLEASE WAIT
        <div class="snippet" data-title=".dot-flashing">
          <div class="stage">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </span>
    </div>

    <div
      :class="{
        'disabled-avg': avgMode === false
      }"
      class="radio-time-frames"
      @click="getAvgStats()"
      v-if="Object.keys(reportLeft).length > 0"
    >
      <span class="filter-buttons radio-frames date-groups">
        <div>
          <input
            class="filter"
            @click="changeAvgFilter($event)"
            type="radio"
            name="time-filters"
            id="7"
            value="7"
            checked
          />
          <label class="filter-title for-date-groups" for="7">7</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeAvgFilter($event)"
            type="radio"
            name="time-filters"
            id="30"
            value="30"
          />
          <label class="filter-title for-date-groups" for="30">30</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeAvgFilter($event)"
            type="radio"
            name="time-filters"
            id="90"
            value="90"
          />
          <label class="filter-title for-date-groups" for="90">90</label>
        </div>
        <div>
          <input
            class="filter"
            @click="changeAvgFilter($event)"
            type="radio"
            name="time-filters"
            id="180"
            value="180"
          />
          <label class="filter-title for-date-groups" for="180">180</label>
        </div>
      </span>
    </div>

    <div class="stats-compare-calendars">
      <div class="report-options" v-if="Object.keys(reportLeft).length > 0">
        <span class="filter-buttons groups">
          <div>
            <input
              class="filter"
              @click="changeFilter($event)"
              type="radio"
              name="filters"
              id="reg"
              value="REG"
              checked
            />
            <label class="filter-title for-groups" for="reg">REG</label>
          </div>
          <div>
            <input
              class="filter"
              @click="changeFilter($event)"
              type="radio"
              name="filters"
              id="dup"
              value="DUP"
            />
            <label class="filter-title for-groups" for="dup">DUP</label>
          </div>
          <div>
            <input
              class="filter"
              @click="changeFilter($event)"
              type="radio"
              name="filters"
              id="all"
              value="ALL"
            />
            <label class="filter-title for-groups" for="all">ALL</label>
          </div>
        </span>
        <div
          class="report-calendar permanent-a"
          :class="{
            'disabled-avg': avgMode === true
          }"
        >
          <date-picker
            lang="en"
            inline
            :disabled-date="notAfterToday"
            :get-classes="getClasses"
            v-model="reportDate"
            @input="getReportByDate"
          ></date-picker>
        </div>
      </div>
      <table
        id="comp-table"
        class="data-compare-table"
        v-if="
          Object.keys(reportLeft).length > 0 &&
            Object.keys(reportRight).length > 0
        "
      >
        <tr>
          <th class="table-header">
            <span v-if="avgMode">{{ avgFilterOption }} days</span>
            <span v-else>{{ formatDate(reportDate) }}</span>
          </th>
          <th class="table-header">
            <button
              @click="applySorting(1, 1)"
              class="btn btn-default btn-sm override"
            >
              <span
                class="fa"
                :class="{
                  'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                  'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                }"
              ></span>
            </button>
          </th>
          <th></th>
          <th></th>
          <th class="table-header">{{ formatDate(reportCmpDate) }}</th>
          <th class="table-header">
            <button
              @click="applySorting(1, 5)"
              class="btn btn-default btn-sm override"
            >
              <span
                class="fa"
                :class="{
                  'fas fa-sort-numeric-down': sortOrder[0] === 'asc',
                  'fas fa-sort-numeric-up': sortOrder[0] === 'desc'
                }"
              ></span>
            </button>
          </th>
        </tr>
        <tr
          v-for="tab in statsTabs"
          :key="tab.id"
          v-if="reportLeft[tab.alias] && reportRight[tab.alias]"
        >
          <td>{{ tab.name }}</td>
          <td>
            <span
              class="stats-tabs-numbers"
              v-if="
                reportLeft[tab.alias]['all_data'][filterOption].length === 0 &&
                  Array.isArray(reportLeft[tab.alias]['all_data'][filterOption])
              "
            >
              -
            </span>
            <span v-else class="stats-tabs-numbers">
              <span
                v-if="
                  Array.isArray(reportLeft[tab.alias]['all_data'][filterOption])
                "
                :class="
                  reportCmp[tab.alias]['all_data'][filterOption][0]
                    .total_in_time_frame -
                    report[tab.alias]['all_data'][filterOption][0]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative'
                "
              >
                {{
                  reportLeft[tab.alias]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
              </span>
              <span v-else>
                <span
                  v-if="tab.alias == 'cc_decline_deposits'"
                  :class="
                    reportCmp[tab.alias]['all_data'][filterOption]
                      .total_deposits_in_time_frame -
                      report[tab.alias]['all_data'][filterOption]
                        .total_deposits_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative'
                  "
                >
                  {{
                    reportLeft[tab.alias]["all_data"][filterOption]
                      .total_deposits_in_time_frame
                  }}
                </span>
                <span
                  v-else
                  :class="
                    reportCmp[tab.alias]['all_data'][filterOption]
                      .total_in_time_frame -
                      report[tab.alias]['all_data'][filterOption]
                        .total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative'
                  "
                >
                  {{
                    reportLeft[tab.alias]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                </span>
              </span>
            </span>
          </td>
          <td>
            <span
              class="stats-tabs-numbers"
              v-if="
                reportCmp[tab.alias]['all_data'][filterOption].length === 0 ||
                  report[tab.alias]['all_data'][filterOption].length === 0
              "
            >
              <span
                v-if="
                  reportCmp[tab.alias]['all_data'][filterOption].length === 0 &&
                    report[tab.alias]['all_data'][filterOption].length === 0
                "
                >-</span
              >
              <span v-else>
                <span
                  v-if="
                    report[tab.alias]['all_data'][filterOption].length === 0
                  "
                  class="stats-tabs-numbers negative"
                >
                  <span
                    v-if="
                      Array.isArray(
                        reportCmp[tab.alias]['all_data'][filterOption]
                      )
                    "
                  >
                    -{{
                      reportCmp[tab.alias]["all_data"][filterOption][0]
                        .total_in_time_frame
                    }}
                  </span>
                  <span v-else>
                    <span v-if="tab.alias == 'cc_decline_deposits'">
                      -{{
                        reportCmp[tab.alias]["all_data"][filterOption]
                          .total_deposits_in_time_frame
                      }}
                    </span>
                    <span v-else>
                      -{{
                        reportCmp[tab.alias]["all_data"][filterOption]
                          .total_in_time_frame
                      }}
                    </span>
                  </span>
                </span>
                <span v-else class="stats-tabs-numbers positive-overlap">
                  <span
                    v-if="
                      Array.isArray(report[tab.alias]['all_data'][filterOption])
                    "
                  >
                    +{{
                      report[tab.alias]["all_data"][filterOption][0]
                        .total_in_time_frame
                    }}
                  </span>
                  <span v-else>
                    <span v-if="tab.alias == 'cc_decline_deposits'">
                      +{{
                        report[tab.alias]["all_data"][filterOption]
                          .total_deposits_in_time_frame
                      }}
                    </span>
                    <span v-else>
                      +{{
                        report[tab.alias]["all_data"][filterOption]
                          .total_in_time_frame
                      }}
                    </span>
                  </span>
                </span>
              </span>
            </span>
            <span v-else class="stats-tabs-numbers">
              <span
                v-if="
                  Array.isArray(
                    reportCmp[tab.alias]['all_data'][filterOption]
                  ) &&
                    Array.isArray(report[tab.alias]['all_data'][filterOption])
                "
                :class="[
                  report[tab.alias]['all_data'][filterOption][0]
                    .total_in_time_frame -
                    reportCmp[tab.alias]['all_data'][filterOption][0]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative',
                  {
                    'zero-color':
                      report[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption][0]
                          .total_in_time_frame ===
                      0
                  }
                ]"
              >
                <span
                  v-if="
                    report[tab.alias]['all_data'][filterOption][0]
                      .total_in_time_frame -
                      reportCmp[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame >=
                      0
                  "
                  >+</span
                >{{
                  report[tab.alias]["all_data"][filterOption][0]
                    .total_in_time_frame -
                    reportCmp[tab.alias]["all_data"][filterOption][0]
                      .total_in_time_frame
                }}
              </span>
              <span v-else>
                <span
                  v-if="
                    Array.isArray(
                      reportCmp[tab.alias]['all_data'][filterOption]
                    )
                  "
                  :class="[
                    report[tab.alias]['all_data'][filterOption]
                      .total_in_time_frame -
                      reportCmp[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        report[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption][0]
                            .total_in_time_frame ===
                        0
                    }
                  ]"
                >
                  <span
                    v-if="
                      report[tab.alias]['all_data'][filterOption]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption][0]
                          .total_in_time_frame >=
                        0
                    "
                    >+</span
                  >{{
                    report[tab.alias]["all_data"][filterOption]
                      .total_in_time_frame -
                      reportCmp[tab.alias]["all_data"][filterOption][0]
                        .total_in_time_frame
                  }}
                </span>
                <span
                  v-if="
                    Array.isArray(report[tab.alias]['all_data'][filterOption])
                  "
                  :class="[
                    report[tab.alias]['all_data'][filterOption][0]
                      .total_in_time_frame -
                      reportCmp[tab.alias]['all_data'][filterOption]
                        .total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        report[tab.alias]['all_data'][filterOption][0]
                          .total_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption]
                            .total_in_time_frame ===
                        0
                    }
                  ]"
                >
                  <span
                    v-if="
                      report[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame >=
                        0
                    "
                    >+</span
                  >{{
                    report[tab.alias]["all_data"][filterOption][0]
                      .total_in_time_frame -
                      reportCmp[tab.alias]["all_data"][filterOption]
                        .total_in_time_frame
                  }}
                </span>
                <span v-else>
                  <span
                    v-if="tab.alias == 'cc_decline_deposits'"
                    :class="[
                      report[tab.alias]['all_data'][filterOption]
                        .total_deposits_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption]
                          .total_deposits_in_time_frame >=
                      0
                        ? 'positive-overlap'
                        : 'negative',
                      {
                        'zero-color':
                          report[tab.alias]['all_data'][filterOption]
                            .total_deposits_in_time_frame -
                            reportCmp[tab.alias]['all_data'][filterOption]
                              .total_deposits_in_time_frame ===
                          0
                      }
                    ]"
                  >
                    <span
                      v-if="
                        report[tab.alias]['all_data'][filterOption]
                          .total_deposits_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption]
                            .total_deposits_in_time_frame >=
                          0
                      "
                      >+</span
                    >{{
                      report[tab.alias]["all_data"][filterOption]
                        .total_deposits_in_time_frame -
                        reportCmp[tab.alias]["all_data"][filterOption]
                          .total_deposits_in_time_frame
                    }}
                  </span>
                  <span
                    v-else
                    :class="[
                      report[tab.alias]['all_data'][filterOption]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame >=
                      0
                        ? 'positive-overlap'
                        : 'negative',
                      {
                        'zero-color':
                          report[tab.alias]['all_data'][filterOption]
                            .total_in_time_frame -
                            reportCmp[tab.alias]['all_data'][filterOption]
                              .total_in_time_frame ===
                          0
                      }
                    ]"
                  >
                    <span
                      v-if="
                        report[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption]
                            .total_in_time_frame >=
                          0
                      "
                      >+</span
                    >{{
                      report[tab.alias]["all_data"][filterOption]
                        .total_in_time_frame -
                        reportCmp[tab.alias]["all_data"][filterOption]
                          .total_in_time_frame
                    }}
                  </span>
                </span>
              </span>
            </span>
          </td>
          <td>
            <span
              class="stats-tabs-numbers"
              v-if="
                reportCmp[tab.alias]['all_data'][filterOption].length === 0 ||
                  report[tab.alias]['all_data'][filterOption].length === 0
              "
              >-
              <!--              <span-->
              <!--                v-if="-->
              <!--                  reportCmp[tab.alias]['all_data'][filterOption].length === 0 &&-->
              <!--                    report[tab.alias]['all_data'][filterOption].length === 0-->
              <!--                "-->
              <!--                >-</span-->
              <!--              >-->
              <!--              <span v-else>-->
              <!--                <span-->
              <!--                  v-if="-->
              <!--                    report[tab.alias]['all_data'][filterOption].length === 0-->
              <!--                  "-->
              <!--                  class="stats-tabs-numbers negative"-->
              <!--                >-->
              <!--                  <span-->
              <!--                    v-if="-->
              <!--                      Array.isArray(-->
              <!--                        reportCmp[tab.alias]['all_data'][filterOption]-->
              <!--                      )-->
              <!--                    "-->
              <!--                  >-->
              <!--                    -{{-->
              <!--                      reportCmp[tab.alias]["all_data"][filterOption][0]-->
              <!--                        .total_in_time_frame-->
              <!--                    }}-->
              <!--                  </span>-->
              <!--                  <span v-else>-->
              <!--                    <span v-if="tab.alias == 'cc_decline_deposits'">-->
              <!--                      -{{-->
              <!--                        reportCmp[tab.alias]["all_data"][filterOption]-->
              <!--                          .total_deposits_in_time_frame-->
              <!--                      }}-->
              <!--                    </span>-->
              <!--                    <span v-else>-->
              <!--                      -{{-->
              <!--                        reportCmp[tab.alias]["all_data"][filterOption]-->
              <!--                          .total_in_time_frame-->
              <!--                      }}-->
              <!--                    </span>-->
              <!--                  </span>-->
              <!--                </span>-->
              <!--                <span v-else class="stats-tabs-numbers positive-overlap">-->
              <!--                  <span-->
              <!--                    v-if="-->
              <!--                      Array.isArray(report[tab.alias]['all_data'][filterOption])-->
              <!--                    "-->
              <!--                  >-->
              <!--                    +{{-->
              <!--                      report[tab.alias]["all_data"][filterOption][0]-->
              <!--                        .total_in_time_frame-->
              <!--                    }}-->
              <!--                  </span>-->
              <!--                  <span v-else>-->
              <!--                    <span v-if="tab.alias == 'cc_decline_deposits'">-->
              <!--                      +{{-->
              <!--                        report[tab.alias]["all_data"][filterOption]-->
              <!--                          .total_deposits_in_time_frame-->
              <!--                      }}-->
              <!--                    </span>-->
              <!--                    <span v-else>-->
              <!--                      +{{-->
              <!--                        report[tab.alias]["all_data"][filterOption]-->
              <!--                          .total_in_time_frame-->
              <!--                      }}-->
              <!--                    </span>-->
              <!--                  </span>-->
              <!--                </span>-->
              <!--              </span>-->
            </span>
            <span v-else class="stats-tabs-numbers">
              <span
                v-if="
                  Array.isArray(
                    reportCmp[tab.alias]['all_data'][filterOption]
                  ) &&
                    Array.isArray(report[tab.alias]['all_data'][filterOption])
                "
                :class="[
                  report[tab.alias]['all_data'][filterOption][0]
                    .total_in_time_frame -
                    reportCmp[tab.alias]['all_data'][filterOption][0]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative',
                  {
                    'zero-color':
                      report[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption][0]
                          .total_in_time_frame ===
                      0
                  }
                ]"
              >
                <span
                  v-if="
                    report[tab.alias]['all_data'][filterOption][0]
                      .total_in_time_frame -
                      reportCmp[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame >=
                      0
                  "
                ></span
                >{{
                  (
                    ((report[tab.alias]["all_data"][filterOption][0]
                      .total_in_time_frame -
                      reportCmp[tab.alias]["all_data"][filterOption][0]
                        .total_in_time_frame) /
                      Math.max(
                        1,
                        reportCmp[tab.alias]["all_data"][filterOption][0]
                          .total_in_time_frame
                      )) *
                    100
                  ).toFixed(0) + "%"
                }}
              </span>
              <span v-else>
                <span
                  v-if="
                    Array.isArray(
                      reportCmp[tab.alias]['all_data'][filterOption]
                    )
                  "
                  :class="[
                    report[tab.alias]['all_data'][filterOption]
                      .total_in_time_frame -
                      reportCmp[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        report[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption][0]
                            .total_in_time_frame ===
                        0
                    }
                  ]"
                >
                  <span
                    v-if="
                      report[tab.alias]['all_data'][filterOption]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption][0]
                          .total_in_time_frame >=
                        0
                    "
                  ></span
                  >{{
                    (
                      ((report[tab.alias]["all_data"][filterOption]
                        .total_in_time_frame -
                        reportCmp[tab.alias]["all_data"][filterOption][0]
                          .total_in_time_frame) /
                        Math.max(
                          1,
                          reportCmp[tab.alias]["all_data"][filterOption][0]
                            .total_in_time_frame
                        )) *
                      100
                    ).toFixed(0) + "%"
                  }}
                </span>
                <span
                  v-if="
                    Array.isArray(report[tab.alias]['all_data'][filterOption])
                  "
                  :class="[
                    report[tab.alias]['all_data'][filterOption][0]
                      .total_in_time_frame -
                      reportCmp[tab.alias]['all_data'][filterOption]
                        .total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        report[tab.alias]['all_data'][filterOption][0]
                          .total_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption]
                            .total_in_time_frame ===
                        0
                    }
                  ]"
                >
                  <span
                    v-if="
                      report[tab.alias]['all_data'][filterOption][0]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame >=
                        0
                    "
                  ></span
                  >{{
                    (
                      ((report[tab.alias]["all_data"][filterOption][0]
                        .total_in_time_frame -
                        reportCmp[tab.alias]["all_data"][filterOption]
                          .total_in_time_frame) /
                        Math.max(
                          1,
                          reportCmp[tab.alias]["all_data"][filterOption]
                            .total_in_time_frame
                        )) *
                      100
                    ).toFixed(0) + "%"
                  }}
                </span>
                <span v-else>
                  <span
                    v-if="tab.alias == 'cc_decline_deposits'"
                    :class="[
                      report[tab.alias]['all_data'][filterOption]
                        .total_deposits_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption]
                          .total_deposits_in_time_frame >=
                      0
                        ? 'positive-overlap'
                        : 'negative',
                      {
                        'zero-color':
                          report[tab.alias]['all_data'][filterOption]
                            .total_deposits_in_time_frame -
                            reportCmp[tab.alias]['all_data'][filterOption]
                              .total_deposits_in_time_frame ===
                          0
                      }
                    ]"
                  >
                    <span
                      v-if="
                        report[tab.alias]['all_data'][filterOption]
                          .total_deposits_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption]
                            .total_deposits_in_time_frame >=
                          0
                      "
                    ></span
                    >{{
                      (
                        ((report[tab.alias]["all_data"][filterOption]
                          .total_deposits_in_time_frame -
                          reportCmp[tab.alias]["all_data"][filterOption]
                            .total_deposits_in_time_frame) /
                          Math.max(
                            1,
                            reportCmp[tab.alias]["all_data"][filterOption]
                              .total_deposits_in_time_frame
                          )) *
                        100
                      ).toFixed(0) + "%"
                    }}
                  </span>
                  <span
                    v-else
                    :class="[
                      report[tab.alias]['all_data'][filterOption]
                        .total_in_time_frame -
                        reportCmp[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame >=
                      0
                        ? 'positive-overlap'
                        : 'negative',
                      {
                        'zero-color':
                          report[tab.alias]['all_data'][filterOption]
                            .total_in_time_frame -
                            reportCmp[tab.alias]['all_data'][filterOption]
                              .total_in_time_frame ===
                          0
                      }
                    ]"
                  >
                    <span
                      v-if="
                        report[tab.alias]['all_data'][filterOption]
                          .total_in_time_frame -
                          reportCmp[tab.alias]['all_data'][filterOption]
                            .total_in_time_frame >=
                          0
                      "
                    ></span
                    >{{
                      (
                        ((report[tab.alias]["all_data"][filterOption]
                          .total_in_time_frame -
                          reportCmp[tab.alias]["all_data"][filterOption]
                            .total_in_time_frame) /
                          Math.max(
                            1,
                            reportCmp[tab.alias]["all_data"][filterOption]
                              .total_in_time_frame
                          )) *
                        100
                      ).toFixed(0) + "%"
                    }}
                  </span>
                </span>
              </span>
            </span>
          </td>
          <td>{{ tab.name }}</td>
          <td>
            <span
              class="stats-tabs-numbers"
              v-if="
                reportRight[tab.alias]['all_data'][filterOption].length === 0 &&
                  Array.isArray(
                    reportRight[tab.alias]['all_data'][filterOption]
                  )
              "
            >
              -
            </span>
            <span v-else class="stats-tabs-numbers">
              <span
                v-if="
                  Array.isArray(
                    reportRight[tab.alias]['all_data'][filterOption]
                  )
                "
                :class="
                  report[tab.alias]['all_data'][filterOption][0]
                    .total_in_time_frame -
                    getProperReport(
                      reportCmp[tab.alias]['all_data'][filterOption]
                    ).total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative'
                "
              >
                {{
                  reportRight[tab.alias]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
              </span>
              <span v-else>
                <span
                  v-if="tab.alias == 'cc_decline_deposits'"
                  :class="
                    report[tab.alias]['all_data'][filterOption]
                      .total_deposits_in_time_frame -
                      getProperReport(
                        reportCmp[tab.alias]['all_data'][filterOption]
                      ).total_deposits_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative'
                  "
                >
                  {{
                    reportRight[tab.alias]["all_data"][filterOption]
                      .total_deposits_in_time_frame
                  }}
                </span>
                <span
                  v-else
                  :class="
                    report[tab.alias]['all_data'][filterOption]
                      .total_in_time_frame -
                      getProperReport(
                        reportCmp[tab.alias]['all_data'][filterOption]
                      ).total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative'
                  "
                >
                  {{
                    reportRight[tab.alias]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                </span>
              </span>
            </span>
          </td>
        </tr>
      </table>

      <div
        class="report-options calendar-cmp"
        v-if="Object.keys(reportCmp).length > 0"
      >
        <div class="report-calendar permanent-b">
          <date-picker
            lang="en"
            inline
            :disabled-date="notAfterTomorrow"
            :get-classes="getCmpClasses"
            v-model="reportCmpDate"
            @input="getCmpReportByDate"
          ></date-picker>
        </div>
        <div class="factory-report-date" v-if="factoryReportDate !== null">
          {{ factoryReportDate }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../helpers/api/request";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import UsersPermissionCheck from "../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "DailyStatsComparisonReports.component",
  components: {
    DatePicker
  },
  mixins: [UsersPermissionCheck],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },

  data() {
    return {
      reportBusy: false,
      reportCmpBusy: false,
      filterOption: "REG",
      avgFilterOption: 7,
      factoryReportDate: null,
      avgMode: false,
      reportDate: moment().subtract(1, "days"),
      reportCmpDate: moment().subtract(1, "days"),
      sortOrder: {
        0: "desc",
        1: "desc"
      },
      report: [],
      avgReport: [],
      reportCmp: [],
      reportLeft: [],
      reportRight: [],
      statsTabs: [
        {
          id: 0,
          name: "NEW",
          alias: "registrations"
        },
        {
          id: 1,
          name: "NA",
          alias: "no_answer_agents"
        },
        {
          id: 2,
          name: "SC",
          alias: "scheduled_call_status"
        },
        {
          id: 3,
          name: "SC-AUTO",
          alias: "scheduled_call_auto_status"
        },
        {
          id: 4,
          name: "TRNSF-LIVE",
          alias: "transferred_to_live"
        },
        {
          id: 5,
          name: "TRNSF-ONLINE",
          alias: "transferred_to_online"
        },
        {
          id: 6,
          name: "ASSIGNED",
          alias: "assigned_agents"
        },
        {
          id: 7,
          name: "DEP",
          alias: "deposits"
        },
        {
          id: 8,
          name: "CC-DECLINE",
          alias: "cc_decline_deposits"
        },
        {
          id: 9,
          name: "NI",
          alias: "not_interested_reasons"
        },
        {
          id: 10,
          name: "NR",
          alias: "not_reached"
        },
        {
          id: 11,
          name: "BN",
          alias: "bad_number_reasons"
        }
      ],
      selectedStatsTab: "registrations"
    };
  },
  created() {
    this.getTimelyCmpReport();
  },
  methods: {
    async getTimelyReport(timeFrame) {
      if (!this.reportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/timely_report/${timeFrame}`
          ).get("");
          this.reportDate = moment(res.data["time_created"]["date"])
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          this.reportLeft = res.data["report"];
          this.indicateLatestReport();
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    async getTimelyCmpReport() {
      if (!this.reportCmpBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.$emit("fetchLiveData");
          this.reportCmpBusy = true;
          const res = await apiClientCreator(`reports/timely_report/1`).get("");
          this.reportCmpDate = moment(res.data["time_created"]["date"])
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          // const res = await apiClientCreator(
          //   `reports/timely_report/compare_today_data/live`
          // ).get("");
          // this.reportCmpDate = moment().format("YYYY-MM-DD");
          await this.getReportByDate(this.reportCmpDate, true);
          this.reportRight = res.data["report"];
          this.indicateLatestReport();
          this.$emit("endFetch");
          this.reportCmpBusy = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    changeFilter(event) {
      this.filterOption = event.target.value;
    },
    changeAvgFilter(event) {
      if (this.avgReport.length > 0) {
        this.avgFilterOption = event.target.value;
        this.reportLeft = this.avgReport[this.avgFilterOption];
        this.indicateLatestReport();
      }
    },
    async getReportByDate(timeFrame, firstTime = false) {
      this.avgMode = false;
      if (firstTime) {
        timeFrame = moment(timeFrame)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        this.reportDate = timeFrame;
      }
      timeFrame = moment(timeFrame)
        .add(1, "days")
        .format("YYYY-MM-DD");
      if (!this.reportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.avgMode = false;
          this.factoryReportDate = null;
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/timely_report_by_date/1/${timeFrame}`
          ).get("");
          this.reportLeft = res.data;
          this.indicateLatestReport();
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    async getCmpReportByDate(timeFrame) {
      timeFrame = moment(timeFrame)
        .add(1, "days")
        .format("YYYY-MM-DD");

      if (!this.reportCmpBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.reportCmpBusy = true;
          if (
            moment(this.reportCmpDate).format("YYYY-MM-DD") !=
            moment().format("YYYY-MM-DD")
          ) {
            this.factoryReportDate = null;
            const res = await apiClientCreator(
              `reports/timely_report_by_date/1/${timeFrame}`
            ).get("");
            this.reportRight = res.data;
          } else {
            this.$emit("fetchLiveData");
            const res = await apiClientCreator(
              `reports/timely_report/compare_today_data/live/true`
            ).get("");
            this.reportRight = this.parseLiveReport(res.data["report"]);
            this.factoryReportDate = res.data["date"];
            this.$emit("endFetch");
          }
          this.indicateLatestReport();
          this.reportCmpBusy = false;
        } catch (e) {}
      }
    },
    notAfterToday(date) {
      return date > moment().subtract(1, "days");
    },
    notAfterTomorrow(date) {
      return date > moment();
    },
    getClasses(date) {
      if (
        moment(this.reportDate).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
      ) {
        return "highlight";
      }
      return "";
    },
    getCmpClasses(date) {
      if (
        moment(this.reportCmpDate).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
      ) {
        return "highlight";
      }
      return "";
    },
    indicateLatestReport() {
      if (this.reportDate >= this.reportCmpDate) {
        this.report = this.reportLeft;
        this.reportCmp = this.reportRight;
      } else {
        this.report = this.reportRight;
        this.reportCmp = this.reportLeft;
      }
    },
    async getAvgStats() {
      this.avgMode = true;
      this.reportDate = moment(this.reportCmpDate)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      if (!this.reportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          if (Array.isArray(this.avgReport)) {
            const res = await apiClientCreator(
              `reports/timely_report/average_report/overall/true`
            ).get("");
            this.avgReport = res.data["workdays"];
          }
          this.reportLeft = this.avgReport[this.avgFilterOption];
          this.indicateLatestReport();
        } catch (e) {}
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getProperReport(report) {
      return Array.isArray(report) ? report[0] : report;
    },
    parseLiveReport(data) {
      let aliases = {
        registrations: "NEW",
        no_answer_agents: "NA",
        scheduled_call_status: "CA",
        scheduled_call_auto_status: "AUTO_CA",
        transferred_to_live: "TR-LV",
        transferred_to_online: "TR-ON",
        assigned_agents: "ASSIGNMENTS",
        deposits: "DEP",
        cc_decline_deposits: "CC-DEC",
        not_interested_reasons: "NI",
        not_reached: "NR",
        bad_number_reasons: "BN"
      };
      let exceptions = [
        "registrations",
        "deposits",
        "cc_decline_deposits",
        "not_reached"
      ];
      let tempReports = {};
      for (const [key, value] of Object.entries(aliases)) {
        tempReports[key] = {};
        tempReports[key]["all_data"] = {};
        for (const filter of ["ALL", "REG", "DUP"]) {
          if (!exceptions.includes(key)) {
            tempReports[key]["all_data"][filter] = [];
            let temp = [];
            temp.total_in_time_frame =
              data[filter]["all_tiers"]["total_in_filter"][value];
            tempReports[key]["all_data"][filter].push(temp);
          } else {
            tempReports[key]["all_data"][filter] = {};
            if (key === "cc_decline_deposits") {
              tempReports[key]["all_data"][
                filter
              ].total_deposits_in_time_frame =
                data[filter]["all_tiers"]["total_in_filter"][value];
            } else {
              tempReports[key]["all_data"][filter].total_in_time_frame =
                data[filter]["all_tiers"]["total_in_filter"][value];
            }
          }
        }
      }
      return tempReports;
    },
    applySorting(typeSort, tableColumn) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById("comp-table");
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              x = x
                .getElementsByTagName("SPAN")[0]
                .getElementsByTagName("SPAN")[0];
              if (x.getElementsByTagName("SPAN")[0] !== undefined) {
                x = x.getElementsByTagName("SPAN")[0];
              }
              y = y
                .getElementsByTagName("SPAN")[0]
                .getElementsByTagName("SPAN")[0];
              if (y.getElementsByTagName("SPAN")[0] !== undefined) {
                y = y.getElementsByTagName("SPAN")[0];
              }
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              x = x
                .getElementsByTagName("SPAN")[0]
                .getElementsByTagName("SPAN")[0];
              if (x.getElementsByTagName("SPAN")[0] !== undefined) {
                x = x.getElementsByTagName("SPAN")[0];
              }
              y = y
                .getElementsByTagName("SPAN")[0]
                .getElementsByTagName("SPAN")[0];
              if (y.getElementsByTagName("SPAN")[0] !== undefined) {
                y = y.getElementsByTagName("SPAN")[0];
              }
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    }
  }
};
</script>

<style scoped>
* {
  font-size: 0.45vw;
}
.main-tabs-cmp {
  max-width: 70%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 2;
}

.main-tabs-cmp.style2 li {
  max-height: 10%;
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}

.main-tabs-cmp.style2 li:not(:last-child) {
  /*margin-right: 2px;*/
}

.main-tabs-cmp li {
  max-width: 100%;
  min-width: 92px;
  height: 18px;
  cursor: pointer;
  background: white;
  border-radius: 0;
  text-align: left;
  vertical-align: middle;
  line-height: 25px;
  border-bottom: 2px solid transparent;
  flex-grow: 2;
  transition: background 0.2s ease, color 0.2s ease;
}

.main-tabs-cmp li:not(.empty):hover {
  transform: translateY(1px);
}

.main-tabs-cmp li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.main-tabs-cmp.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.main-tabs-cmp.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.chart-box-cmp {
  display: flex;
  background-color: white;
  justify-content: space-between;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
  max-height: 200px;
}
.negative {
  color: red;
}
.positive-overlap {
  color: green;
}
.report-rank {
  font-size: 0.65vw;
}
.daily-report-tab {
  font-size: 0.65vw;
  display: flex;
  flex: 3;
  flex-direction: column;
  justify-content: center;
  padding-left: 2em;
}
.daily-stats-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 0.7vw;
}
.stats-tabs-numbers {
}
.top-stat-title {
  padding-bottom: 1em;
}
.filter-buttons {
  display: flex;
  justify-content: center;
}
.filter {
  margin: 0.4em !important;
}
.filter-title {
  margin-bottom: 2px;
  font-weight: bold;
  font-size: 13px;
}
.report-options {
  display: flex;
  flex-direction: column;
  font-size: 0.7vw;
}
.report-data-cmp {
  display: flex;
  flex: 1;
  padding: 0.4em;
}
.mx-datepicker-inline {
  border: none !important;
}
.report-calendar .mx-calendar-content {
  height: 135px !important;
}
.report-calendar .mx-table-date td,
.mx-table-date th {
  height: 25px !important;
}
.report-calendar .today {
  color: darkblue;
}
.report-calendar .mx-calendar-header {
  height: 30px;
}
.highlight {
  color: white;
  background: #2a90e9;
}
.report-cmp {
  justify-content: flex-end;
}
.calendar-cmp {
  margin-top: 25px;
}
.cmp-tabs {
  font-size: 0.7vw;
  margin: 0;
  list-style: none;
  -webkit-box-orient: vertical;
  padding: 0.8em 0 0 0;
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.data-compare-table {
  font-size: 0.65vw;
  width: 100%;
  margin-right: 2px;
}
.data-compare-table td {
  padding: 0 0.7em;
}
.stats-compare-calendars {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  min-height: 200px;
}
.disabled-avg {
  opacity: 0.3;
}
.table-header {
  text-align: center;
}
.factory-report-date {
  font-size: 0.65vw;
  display: flex;
  justify-content: center;
  font-weight: bold;
}
.zero-color {
  color: orange !important;
}
.radio-frames {
  flex-direction: row;
}
.radio-time-frames {
  width: 3%;
}
.btn-sm {
  padding: 0 1px 3px 0;
  font-size: 0.7vw;
  line-height: 1.5;
  border: none;
  background: transparent;
}
.btn-sm:active {
  border: none;
  outline: none;
}
.btn-sm:focus {
  border: none;
  outline: none;
}
.mx-calendar {
  width: 180px !important;
}
.mx-table {
  width: 85% !important;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 34%;
  top: 50%;
  font-size: 12px;
}

/*.loader {*/
/*  position: absolute;*/
/*  top: 40%;*/
/*  right: 50%;*/
/*  border: 4px solid #f3f3f3; !* Light grey *!*/
/*  border-top: 4px solid #3498db; !* Blue *!*/
/*  border-radius: 50%;*/
/*  width: 40px;*/
/*  height: 40px;*/
/*  animation: spin 2s linear infinite;*/
/*}*/

/*@keyframes spin {*/
/*  0% {*/
/*    transform: rotate(0deg);*/
/*  }*/
/*  100% {*/
/*    transform: rotate(360deg);*/
/*  }*/
/*}*/
.d-none-for-loader {
  display: none;
}
.report-calendar.permanent-a {
  position: absolute;
  left: 25px;
  top: 20px;
}
.report-calendar.permanent-b {
  position: absolute;
  right: 20px;
  top: 20px;
}
.groups {
  position: absolute;
  top: 2px;
  z-index: 2;
  left: 490px;
}
.date-groups {
  position: absolute;
  top: 2px;
  z-index: 2;
  left: 50px;
  z-index: 2;
}
.for-groups {
  font-size: 10px !important;
}
.for-date-groups {
  font-size: 10px !important;
  font-weight: 500;
}
</style>
